// Validate if the input is a number or a dot
export const isNumberOrDot = (e) => {
  return !/[0-9.]/.test(e.key) && e.preventDefault()
}
